import React from 'react'
import DashboardShell from './shell/dashboard-shell'
import { Outlet } from 'react-router-dom'
import { DesignProvider } from 'context/design.js'
import { AdminLayoutProvider } from 'context/admin-layout'

function AdminLayout() {
  // useEffect(() => {
  //   var Tawk_API = window.Tawk_API || {}
  //   var Tawk_LoadStart = new Date()

  //   const script = document.createElement('script')
  //   script.async = true
  //   script.src = 'https://embed.tawk.to/69d4d78d48ae561c374c97a9/1jljmk0vi'
  //   script.charset = 'UTF-8'
  //   script.setAttribute('crossorigin', '*')

  //   document.body.appendChild(script)

  //   return () => {
  //     // optional cleanup (removes script if component unmounts)
  //     document.body.removeChild(script)
  //   }
  // }, [])

  return (
    <AdminLayoutProvider>
      <DesignProvider>
        <DashboardShell>
          <Outlet />
        </DashboardShell>
      </DesignProvider>
    </AdminLayoutProvider>
  )
}

export default AdminLayout
